import styled from 'styled-components'

export const Container = styled.div`
  position: relative;

  @media (max-width: 1200px) {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 54px;
  }

  @media (max-width: 480px) {
    top: 107px;
  }
`

export const MenuDescription = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

export const Text = styled.div<{ textColor: string | undefined }>`
  cursor: pointer;
  margin-left: 8px;
  font-size: 15px;
  line-height: 18px;
  color: ${(props) => (props.textColor !== '' ? props.textColor : 'white')};

  @media (max-width: 480px) {
    font-size: 0.75rem;
    line-height: 20px;
    color: ${(props) => props.theme.colors.white};
    margin-left: 0.25rem;
  }
`

type ContentProps = {
  isActive: boolean
}

export const ContentBox = styled.div<ContentProps>`
  ${(props) => !props.isActive && `display: none`}
  z-index: 1003;
  height: auto;
  position: absolute;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-color: #ffffff;
  box-shadow: 0px 8px 25px rgba(166, 166, 166, 0.2);
  border-radius: 6px;
  width: 266px;
  top: 28px;
  left: -107px;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s;

  @media (max-width: 1200px) {
    left: -15px;
  }

  &:before {
    content: '';
    width: 14px;
    height: 14px;
    border-radius: 2px;
    transform: rotate(-45deg);
    position: absolute;
    top: -6px;
    right: 50px;
    @media (max-width: 1200px) {
      right: 203px;
    }
    margin-left: -7px;
    background-color: #ffffff;
  }

  ${(props) =>
    props.isActive &&
    `opacity: 1;
    pointer-events: all;
    top: 33px;
    transition: all 0.3s`}
`

export const TypedContainer = styled.div`
  padding: 24px 24px 0 24px;
`

export const Title = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.colors.grey[300]};
  text-align: center;
`

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 24px;
`
